import { render, staticRenderFns } from "./StatementsList.vue?vue&type=template&id=f2a58fd0&"
import script from "./StatementsList.vue?vue&type=script&lang=js&"
export * from "./StatementsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports